// extracted by mini-css-extract-plugin
module.exports = {"product-card":"ProductCard_product-card__AofLz","product-card__img":"ProductCard_product-card__img__PkaZi","product-card__actions":"ProductCard_product-card__actions__ojAg5"};